import React from 'react';
import $ from 'jquery';

import BaseClass from '@/pages/BaseClass';

import {
	ngUrl,
	pcUrl,
	httpPost,
	CommonValue,
	message,
} from '@/utils/tools';

export default class App extends BaseClass
{
	constructor(props)
	{
		super(props);
		this.state={
			'hideQr':false,
			'qrUrl':'',
		};
	}
	
	componentDidMount()
	{
		this.getQrUrl();
	}
	
	toggleQr()
	{
		let hideQr = !this.state.hideQr;
		this.setState({ hideQr });
	}
	
	getQrUrl()
	{
		let url = pcUrl('/dict/data/random?dictType=service_qrcode');
		httpPost(url,'',"GET")
			.then(data=>{
				this.setState({
					'qrUrl':data.dictValue,
				});
			});
	}
	
	render()
	{
		return (
			<div className="tools">
				<div className="toggle-qr">
					<a href="javascript:;" onClick={()=>this.toggleQr()}>{this.state.hideQr ? '客服':'客服'}</a>
				</div>
				<div className={["wechat-qr",this.state.hideQr?'mini':''].join(' ')}>
					<img src={this.state.qrUrl || require("@/assets/images/wechat_qr.jpg")} />
				</div>
			</div>
		);
	}
}



